export { ChoiceDetails, ChoiceDetails as default } from './choice-details';
